const BASE_URL = 'ai-service/api/annotation-ai-objects'

const annotationAiObjectsRequests = {
  getAnnotationAiObjectsRequest: (data) => ({
    url: `${BASE_URL}/existing`,
    method: 'post',
    data,
  }),
}

export default annotationAiObjectsRequests
